import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';

function Navbar() {
    return (
        <nav className="navbar">
             <div className="nav-center">
                 <Link to="/">
                     <img src={logo} alt="cocktail db logo" className="logo"></img>
                 </Link>
                 <span><h1>Last Shot 🍺</h1></span>
                 <ul className="nav-links">
                     <li><Link to="/">
                         Home
                         </Link>
                    </li>
                     <li><Link to="/about">
                         About
                         </Link>
                    </li>
                 </ul>
             </div>
        </nav>
    )
}


export default Navbar
